import { useTranslation } from 'react-i18next'

//
import { ChartDataType } from 'common/components/charts/Pie'

import { Pie } from 'common/components'

import { formatMoney } from '../../../common/moneyFormatter'

//
import './style.less'

type StatisticCardProps = {
  data: ChartDataType[]
  innerPie: {
    title: string
    content: string
  }
  amount: {
    spent: string
    total: string
  }
  trend?: {
    value: number
    increasing: boolean
  }
  width?: number
  height?: number
  loading?: boolean
}

const StatisticCard = ({ width = 140, height = 140, ...props }: StatisticCardProps) => {
  const { t } = useTranslation()
  let { data: mutableData, innerPie: mutableStatistics } = props

  /**
   * Prevent NaN from appearing in the chart, if the data is not valid,
   * fallback to 0
   */
  mutableData.forEach((item) => {
    item.value = item.value || 0
  })

  mutableStatistics.content = `${formatMoney(parseFloat(mutableStatistics.content) || 0, false)}%`

  return (
    <div className="allowance-statistic__wrap">
      <div className="allowance-statistic__content-wrap">
        <p className="allowance-statistic__title t-allowance-statistic-title">{props.amount.spent}</p>
        <p className="allowance-statistic__sub-title t-allowance-statistic-sub-title">
          {t('admin-dashboard.home.statistics.of')} {props.amount.total}
        </p>
        {props.trend && (
          <p className={`allowance-statistic__trend ${props.trend.increasing ? 'increasing' : 'decreasing'}`}></p>
        )}
      </div>

      <div className="allowance-statistic__pie-wrap">
        <Pie
          data={props.data}
          statistics={mutableStatistics}
          width={width}
          height={height}
          style={{
            statisticTitle: {
              display: 'none',
            },
            statisticContent: {
              fontSize: '18px',
              fontWeight: 'bold',
              marginTop: '-7px',
            },
          }}
          loading={props?.loading}
        />
      </div>
    </div>
  )
}

export default StatisticCard
